export default __webpack_public_path__ + "static/media/dt2.674a7428.jpg";